export const isSystemAttribute = (id: number) => {
	return id < 0;
};

export default isSystemAttribute;
